import React from 'react';
import { FormattedMessage, FormattedDate } from '../../util/reactIntl';
import moment from 'moment';
import { LINE_ITEM_NIGHT, DATE_TYPE_DATE, propTypes } from '../../util/types';
import { dateFromAPIToLocalNoon } from '../../util/dates';

import css from './BookingBreakdown.module.css';

const BookingPeriod = props => {
  const { startDate, endDate, dateType, timeZone } = props;


  const timeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
  };

  const dateFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };

  const timeZoneMaybe = timeZone ? { timeZone } : null;

  return (
    <div className={css.bookingDatesClause}>
      <hr className={css.datesDivider} />
      <div className={css.bookingPeriod}>
        <div className={css.dateTimeLabel}>
          <FormattedMessage id="BookingBreakdown.dateTimeLabel" />
        </div>
        <div className={css.dateTimeValue}>
          <FormattedDate value={startDate} {...dateFormatOptions} {...timeZoneMaybe} />
          ,&nbsp;
          <FormattedDate value={startDate} {...timeFormatOptions} {...timeZoneMaybe} />
          -
          <FormattedDate value={endDate} {...timeFormatOptions} {...timeZoneMaybe} />
        </div>
      </div>
    </div>
  );
};

const LineItemBookingPeriod = props => {
  const { booking, unitType, dateType, timeZone } = props;

  // Attributes: displayStart and displayEnd can be used to differentiate shown time range
  // from actual start and end times used for availability reservation. It can help in situations
  // where there are preparation time needed between bookings.
  // Read more: https://www.sharetribe.com/api-reference/marketplace.html#bookings
  const { start, end, displayStart, displayEnd } = booking.attributes;
  const localStartDate = displayStart || start;
  const localEndDateRaw = displayEnd || end;

  const isNightly = unitType === LINE_ITEM_NIGHT;
  const endDay = isNightly ? localEndDateRaw : moment(localEndDateRaw).subtract(1, 'days');

  return (
    <>
      <div className={css.lineItem}>
        <BookingPeriod
          startDate={localStartDate}
          endDate={endDay}
          dateType={dateType}
          timeZone={timeZone}
        />
      </div>
    </>
  );
};
LineItemBookingPeriod.defaultProps = { dateType: null };

LineItemBookingPeriod.propTypes = {
  booking: propTypes.booking.isRequired,
  dateType: propTypes.dateType,
};

export default LineItemBookingPeriod;
